module.exports = __webpack_public_path__ + "img/Consultation_Logo.a78e30f2.png";